// extracted by mini-css-extract-plugin
export default {"-large":"swatches-module__-large--Xh4Ws","container":"swatches-module__container--piFkK"};